import { render, staticRenderFns } from "./AppointmentDetailsCard.vue?vue&type=template&id=f1777ac0"
import script from "./AppointmentDetailsCard.vue?vue&type=script&lang=ts"
export * from "./AppointmentDetailsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports